import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore'
import { RootState } from '@/store'
import UbsRepository, { QrCodeBill, QrCodeBillRequest } from '@/repositories/ubs-repository'

export default class UbsService {
    constructor(private ubsRepository: UbsRepository, private store: ToolkitStore<RootState>) {}

    async getQrCodeBill(payload: QrCodeBillRequest): Promise<QrCodeBill> {
        const res = await this.ubsRepository.getQrCodeBill(payload)
        return res
    }
}
